import angular from 'angular';
import tableExportControlsComponent from './tableExport.component';


let tableExportControlsModule = angular.module('tableExport', [
])

.component('tableExport', tableExportControlsComponent);

export default tableExportControlsModule;



// WEBPACK FOOTER //
// ./client/common/tableExport/tableExport.js